/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Dashboard as DashboardLayout } from 'layouts';
import { useIntl } from 'react-intl';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Breadcrumbs, Grid2, Typography } from '@mui/material';
import theme from 'theme';
import { BarChart, Card, MostConsumeChart } from 'components';
import {
  AttachMoney,
  FlashOn,
  Receipt,
  Timeline,
  TrendingUp,
} from '@mui/icons-material';
import {
  getComparativeYearConsume,
  getDayWithMostConsume,
  getMonthWithMostConsume,
  getTopChargeInMonth,
  getUnifiquedReceipt,
} from 'js/actions/groupDashboardActions';
import Swal from 'sweetalert2';
import ComparativeChart, {
  Dashboard,
} from 'components/ComparativeYearConsumeChart';
import DayWithMostConsumeChart from 'components/DayWithMostConsumeChart';
import TopChart from './TopChart';

export default function GroupDashboard() {
  const intl = useIntl();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { meter } = location.state;
  const { group } = location.state;
  const { user } = useSelector((state) => state.user);
  const corporative = location?.state?.corporative;
  const { type_energy, rate_horary } = group;
  const [totalsactualmonth, setTotalsactualmonth] = useState([]);
  const year = new Date().getFullYear();
  const currentMonth =
    new Date().getMonth() + 1 <= 9
      ? `0${new Date().getMonth() + 1}`
      : new Date().getMonth() + 1;

  const budgets = group.bill && group.bill === 1 ? 2.4 : 3;

  const {
    receipt,
    monthMostConsume,
    comparativeYearConsume,
    dayMostConsume,
    topChargeInMonth,
  } = useSelector((state) => state.groupDashboard);

  useEffect(() => {
    dispatch(getUnifiquedReceipt(group.id, year, currentMonth));
    dispatch(getMonthWithMostConsume(group.id, year));
    dispatch(getComparativeYearConsume(group.id, year));
    dispatch(getDayWithMostConsume(group.id, year, currentMonth));
    dispatch(getTopChargeInMonth(group.id));
  }, [group, currentMonth, year, dispatch]);

  const handleReceipt = () => {
    if (receipt.length === 0) {
      Swal.fire({
        title: 'Recibo no disponible',
        icon: 'warning',
      });
    } else {
      window.open(receipt.data, '_blank');
    }
  };

  useEffect(() => {
    let data = [];
    if (rate_horary === 1) {
      const consume = [group.consumes[0], group.consumes[1]];
      data = consume.map((element) =>
        element
          .filter((e) => e !== 'kW' && e !== 'kWh')
          .map((e) => parseFloat(e.replace(/,/g, '')))
      );
    } else {
      data = [
        parseFloat(group.consumes.total_kwh.replace(/,/g, '')),
        parseFloat(group.consumes.demand_max.replace(/,/g, '')),
      ];
    }

    setTotalsactualmonth(data);
  }, [group, rate_horary]);

  return (
    <DashboardLayout>
      <Box p={4}>
        <Typography
          variant="h2"
          sx={{ mb: theme.spacing(2), color: '#A53693' }}
        >
          {intl.formatMessage({ id: 'app.group.board.title' })}
        </Typography>
        <Box display="flex">
          <Breadcrumbs
            aria-label="breadcrumb"
            separator=":"
            sx={{ paddingRight: '.5rem' }}
          >
            <Link
              underline="hover"
              style={{ color: '#A53693' }}
              to={`/corporative/${meter.corporative_id ? meter.corporative_id : corporative.id}`}
              state={meter}
            >
              {intl.formatMessage({ id: 'app.meters.nav.meters' })}
            </Link>
            <Link
              underline="hover"
              color="inherit"
              style={{ color: '#66788A' }}
              to={`/corporative/${meter.corporative_id ? meter.corporative_id : corporative.id}`}
              state={meter}
            >
              {meter
                ? meter.name
                : intl.formatMessage({ id: 'app.groups.nav.groupLab2' })}
            </Link>
          </Breadcrumbs>
          <Typography sx={{ fontWeight: 600, color: '#00AFEF' }}>
            {' '}
            |{' '}
          </Typography>
          <Breadcrumbs
            aria-label="breadcrumb"
            separator=":"
            sx={{ paddingLeft: '.5rem' }}
          >
            <Link
              underline="hover"
              style={{ color: '#A53693' }}
              to={`/meter/${meter.id}`}
              state={{
                meter: meter,
                corporative: corporative,
              }}
            >
              {intl.formatMessage({ id: 'app.charges.nav.groupLab2' })}
            </Link>
            <Typography variant="h5">{group.name}</Typography>
          </Breadcrumbs>
        </Box>
        <Grid2 container={true} spacing={2} pt={2}>
          <Grid2 size={{ lg: budgets, sm: 6, xs: 12 }}>
            <Card
              bgColor="#A53693"
              title={
                type_energy === 2
                  ? intl.formatMessage({
                      id: 'app.groupSolar.board.mainHead.dayConsumption',
                    })
                  : intl.formatMessage({
                      id: 'app.group.board.mainHead.dayConsumption',
                    })
              }
              data={group ? `${group.consumes.total_kwh} kWh` : null}
              footer={false}
              icon={
                <TrendingUp
                  sx={{
                    color: '#A53693',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          <Grid2 size={{ lg: budgets, sm: 6, xs: 12 }}>
            <Card
              bgColor="#00AFEF"
              title={
                type_energy === 2
                  ? intl.formatMessage({
                      id: 'app.groupSolar.board.mainHead.maxDemand',
                    })
                  : intl.formatMessage({
                      id: 'app.group.board.mainHead.maxDemand',
                    })
              }
              data={group ? `${group.consumes.demand_max} kW` : null}
              footer={false}
              icon={
                <FlashOn
                  sx={{
                    color: '#00AFEF',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          <Grid2 size={{ lg: budgets, sm: 6, xs: 12 }}>
            <Card
              bgColor="#45B880"
              title={
                type_energy === 2
                  ? intl.formatMessage({
                      id: 'app.groupSolar.board.mainHead.estimAmtAsOfToday',
                    })
                  : intl.formatMessage({
                      id: 'app.group.board.mainHead.estimAmtAsOfToday',
                    })
              }
              data={
                group
                  ? `$ ${group.consumes.total_average}`
                  : group
                    ? `$ ${group.consumes.total}`
                    : '$ 0.00'
              }
              footer={intl.formatMessage({
                id: 'app.group.board.mainHead.estimAmtAsOfToday.vatNotice',
              })}
              icon={
                <AttachMoney
                  sx={{
                    color: '#45B880',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          {group.bill === 1 && (
            <Grid2 size={{ lg: budgets, sm: 6, xs: 12 }}>
              <Card
                bgColor="#ed685e"
                clicked={true}
                action={handleReceipt}
                title={intl.formatMessage({
                  id: 'app.group.board.mainHead.receiptConsult',
                })}
                footer={intl.formatMessage({
                  id: 'app.group.board.mainHead.receiptConsult.linkMsg',
                })}
                data={' '}
                icon={
                  <Receipt
                    sx={{
                      color: '#ed685e',
                      width: '2rem',
                      height: '2rem',
                      fontSize: '2rem',
                    }}
                  />
                }
              />
            </Grid2>
          )}
          <Grid2 size={{ lg: budgets, sm: 6, xs: 12 }}>
            <Card
              clicked={true}
              bgColor="#EAAB36"
              title={intl.formatMessage({
                id: 'app.group.board.mainHead.charges',
              })}
              data={' '}
              action={() =>
                navigate(`/group/${group?.id}`, {
                  state: {
                    group: group,
                    meter: meter,
                  },
                })
              }
              footer={false}
              icon={
                <Timeline
                  sx={{
                    color: '#EAAB36',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
        </Grid2>
        <Grid2 container={true} spacing={2} pt={2}>
          <Grid2 size={{ lg: 9, md: 9, sm: 12, xs: 12 }}>
            <BarChart
              title={intl.formatMessage({
                id: 'app.meter.board.demandAndConsump.title',
              })}
              custom={rate_horary === 1 ? 0 : 1}
              totalConsumeskW={totalsactualmonth[0]}
              totalConsumeskWh={totalsactualmonth[1]}
            />
          </Grid2>
          <Grid2 size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
            <MostConsumeChart
              title={
                type_energy === 2
                  ? intl.formatMessage({
                      id: 'app.chargeSolar.board.monthHighConsump.title',
                    })
                  : intl.formatMessage({
                      id: 'app.group.board.monthHighConsump.title',
                    })
              }
              year={year}
              monthMostConsume={monthMostConsume}
            />
          </Grid2>
          <Grid2 size={{ lg: 9, md: 9, sm: 12, xs: 12 }}>
            <ComparativeChart
              title={
                type_energy === 2
                  ? intl.formatMessage({
                      id: 'app.chargeSolar.board.difConsumpChart.title',
                    })
                  : intl.formatMessage({
                      id: 'app.group.board.difConsumpChart.title',
                    })
              }
              year={year}
              dashboard={Dashboard.group}
              comparativeYearConsume={comparativeYearConsume}
            />
          </Grid2>
          <Grid2 size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
            <DayWithMostConsumeChart
              title={
                type_energy === 2
                  ? intl.formatMessage({
                      id: 'app.chargeSolar.board.highConsumDayCurrMonth.title',
                    })
                  : intl.formatMessage({
                      id: 'app.group.board.highConsumDayCurrMonth.title',
                    })
              }
              day={dayMostConsume.day}
              consume={dayMostConsume.consume}
              co2={dayMostConsume.co2}
            />
          </Grid2>
          <Grid2 size={12}>
            <TopChart
              rateHorary={rate_horary}
              title={
                type_energy === 2
                  ? intl.formatMessage({
                      id: 'app.meterSolar.board.topCharges.title',
                    })
                  : intl.formatMessage({
                      id: 'app.meter.board.topCharges.title',
                    })
              }
              topChargeInMonth={topChargeInMonth}
            />
          </Grid2>
        </Grid2>
      </Box>
    </DashboardLayout>
  );
}
